import { render, staticRenderFns } from "./ListPermisoParte.vue?vue&type=template&id=6028e8c0&"
import script from "./ListPermisoParte.vue?vue&type=script&lang=js&"
export * from "./ListPermisoParte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports